module.exports = __webpack_public_path__ + "img/news-img1.b655b885.jpg";